import React, { useEffect } from "react";
import "../css/styles.css";
import logo from "../assets/main-logo.png";
import userIcon from "../assets/user.png";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import Choices from "choices.js";
import "choices.js/public/assets/styles/choices.min.css";
import { useAuth0 } from "@auth0/auth0-react";


export default function InquiryRegister() {
  const { logout, user, isAuthenticated } = useAuth0();

  useEffect(() => {

    console.log("job-Register.js is running");
    const monthSelect = document.getElementById("month");
    if (monthSelect) {
      new Choices(monthSelect, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: "",
        placeholder: true,
        placeholderValue: "--Select Month--",
      });
    
    }

    const countrySelect = document.getElementById('country');
    if (countrySelect) {
    new Choices(countrySelect, {
      searchEnabled: true,
      itemSelectText: '',
      shouldSort: false,
    });
    }

    const clientSelect = document.getElementById('client');
    if (clientSelect) {
    new Choices(clientSelect, {
      searchEnabled: true,
      itemSelectText: '',
      shouldSort: false,
    });
    }

    const numberOfDaysUnitSelect = document.getElementById('numberOfDaysUnit');
    if (numberOfDaysUnitSelect) {
    new Choices(numberOfDaysUnitSelect, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false 
    });
    }

    const costCurrencySelect = document.getElementById('costCurrency');
    if (costCurrencySelect) {
    new Choices(costCurrencySelect, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false
    });
    }

    const offeredPriceCurrencySelect = document.getElementById('offeredPriceCurrency');
    if (offeredPriceCurrencySelect) {
    new Choices(offeredPriceCurrencySelect, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false
    });
    }

    const statusSelect = document.getElementById('status');
    if (statusSelect) {
    new Choices(statusSelect, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false  
    });
    }

    const coordinatorSelect = document.getElementById('ownerCoordinator');
    if (coordinatorSelect) {
    new Choices(coordinatorSelect, {
      searchEnabled: false,
      itemSelectText: '',
      shouldSort: false  
    });
    }

    // CALENDER FLATPICKR

    flatpickr("#inquiryDate", {
    dateFormat: "d-m-Y",
    altFormat: "F j, Y",
    allowInput: true,
    });

    flatpickr("#tentativeDate", {
    dateFormat: "d-m-Y",
    altFormat: "F j, Y",
    allowInput: true
    });


  // AUTH0

  // const { loginWithRedirect, logout, isAuthenticated, isLoading, user } = useAuth0();

  // if (isLoading) return <div>Loading...</div>;

  // if (!isAuthenticated) {
  //   loginWithRedirect();
  //   return null;
  // }

  
  // MARGIN CALCULATION 

const costINRInput = document.getElementById('costInINR');
const offerINRInput = document.getElementById('offeredPriceInINR');
const marginInput = document.getElementById('margin');

function calculateMargin() {
  console.log("margin is running")
  const costINR = parseFloat(costINRInput.value);
  const offerINR = parseFloat(offerINRInput.value);

  if (!isNaN(costINR) && !isNaN(offerINR) && offerINR !== 0) {
    const margin = ((offerINR - costINR) / offerINR) * 100;
    marginInput.value = margin.toFixed(2) + '%';
    console.log("running")
  } else {
    marginInput.value = '';
  }
}

// Trigger margin calculation on input changes
costINRInput.addEventListener('input', calculateMargin);
offerINRInput.addEventListener('input', calculateMargin);

// CURRENCY CONVERTER FOR COST

const costInput1 = document.getElementById('cost');
const currencySelect = document.getElementById('costCurrency');
const costInINRInput = document.getElementById('costInINR');

const exchangeRatesToINR = {
  USD: 87.63,
  GBP: 115.97,
  INR: 1,
  AED: 23.86,
  EUR: 101.26
};

function convertToINR() {
  const cost = parseFloat(costInput1.value);
  const currency = currencySelect.value;

  if (!isNaN(cost) && exchangeRatesToINR[currency]) {
    const converted = cost * exchangeRatesToINR[currency];
    costInINRInput.value = converted.toFixed(2);
     calculateMargin();
  } else {
    costInINRInput.value = '';
    calculateMargin();
  }
}

costInput1.addEventListener('input', convertToINR);
currencySelect.addEventListener('change', convertToINR);

// CURRENCY CONVERTER FOR OFFER PRICE

const offerPriceInput = document.getElementById('offeredPrice');
const offeredCurrencySelect = document.getElementById('offeredPriceCurrency');
const offeredInINRInput = document.getElementById('offeredPriceInINR');

const exchangeRatesOfferToINR = {
  USD: 87.63,
  GBP: 115.97,
  INR: 1,
  AED: 23.86,
  EUR: 101.26
}

function offerTOINR() {
  const offerPrice = parseFloat(offerPriceInput.value);
  const offerPriceCurrency = offeredCurrencySelect.value;

  if (!isNaN(offerPrice) && exchangeRatesOfferToINR[offerPriceCurrency]) {
    const offerPriceconverted = offerPrice * exchangeRatesOfferToINR[offerPriceCurrency];
    offeredInINRInput.value = offerPriceconverted.toFixed(2);
    calculateMargin();
  } else {
    offeredInINRInput.value = '';
    calculateMargin();
  }
}

offerPriceInput.addEventListener('input' , offerTOINR);
offeredPriceCurrencySelect.addEventListener('change' , offerTOINR);


  // SUBMIT POPUP 


  const form = document.getElementById('myForm');
  const popup = document.getElementById('popup');

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(form);

    fetch('https://script.google.com/macros/s/AKfycbzDiH81rnd0IZPS1Arf3ddKIzWr9dwbqZ9hx5UNhEkswNlOetVmU8pc1_MoepXWEUjnDA/exec', {
      method: 'POST',
      body: new URLSearchParams(formData)
    })
    .then(response => {
      if (response.ok) {
        popup.style.display = 'block';
        setTimeout(() => popup.style.opacity = '1', 10);
        setTimeout(() => {
          popup.style.opacity = '0';
          setTimeout(() => popup.style.display = 'none', 500);
        }, 5000);
        form.reset();
      } else {
        alert("Submission failed. Try again.");
      }
    })
    .catch(error => {
      console.error("Error:", error);
      alert("Error submitting form.");
    });
  };

  if (form) {
    form.addEventListener('submit', handleSubmit);
  }

  return () => {
    if (form) {
      form.removeEventListener('submit', handleSubmit);
    }
  };

    }

  , []);

  

  return (
    <div className="inquiry-register">
      <input type="checkbox" id="nav-toggle" className="hidden" />
      <div className="sidebar">
        <div className="sidebar-brand">
          <img src={logo} alt="APS Logo" />
        </div>

        <div className="sidebar-menu">
          <ul>
            <li>
              <a className="active">
                <span className="material-symbols-outlined">person</span>
                <i>Inquiry Register</i>
              </a>
            </li>
            <li>
              <a href="/job-register">
                <span className="material-symbols-outlined">work</span>
                <i>Job Register</i>
              </a>
            </li>
            <li>
              <a href="/man-month">
                <span className="material-symbols-outlined">calendar_month</span>
                <i>Man Month Register</i>
              </a>
            </li>
            <li>
              <a href="/inspector-invoice">
                <span className="material-symbols-outlined">contract</span>
                <i>Inspector Invoice</i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="main-content">
        <header>
          <div className="header-title">
            <label htmlFor="nav-toggle">
              <span className="hamburger material-symbols-outlined">dehaze</span>
            </label>
            <h2>Inquiry Register</h2>
          </div>
          <div className="user-wrapper">
            <img src={userIcon} alt="User" width="50" height="50" />
            <div>
              <h4>APS Group</h4>
              <small>Admin</small>
            </div>

            <button className="logout-btn" onClick={() => logout({ returnTo: window.location.origin })}>
            Logout
          </button>

          </div>
        </header>

        <main>
          <div className="form-container">
            <form
              id="myForm"
              autoComplete="off"
              action="https://script.google.com/macros/s/AKfycbzDiH81rnd0IZPS1Arf3ddKIzWr9dwbqZ9hx5UNhEkswNlOetVmU8pc1_MoepXWEUjnDA/exec"
              method="POST"
            >
              <input type="hidden" name="formType" value="inquiry" />

            <div className="form-wrapper">

             <div className="form-section">
              
              <div className="form-group">
                <label htmlFor="month">Month</label>
                <select id="month" name="Month" required>
                  <option value="January">January</option>
                  <option value="February">February</option>
                  <option value="March">March</option>
                  <option value="April">April</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                  <option value="July">July</option>
                  <option value="August">August</option>
                  <option value="September">September</option>
                  <option value="October">October</option>
                  <option value="November">November</option>
                  <option value="December">December</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="jobnumber">Job Number</label>
                <input maxLength="8" type="text" id="jobnumber" name="JobNumber" required />
              </div>

              <div className="form-group">
                <label htmlFor="inquiryDate">Inquiry Date</label>
                <input type="text" id="inquiryDate" name="InquiryDate" required />
              </div>

             </div>

             <div className="form-section">

              <div className="form-group">
                <label htmlFor="inquirySource">Inquiry Source</label>
                <input type="text" id="inquirySource" name="InquirySource" required />
              </div> 

              <div className="form-group">
                <label htmlFor="client">Client</label>
                <select id="client" name="Client" required>
                    <option value="">--Select Customer--</option>
  <option value="LRQA - Mumbai">LRQA - Mumbai</option>
  <option value="TISA">TISA</option>
  <option value="BV - Oman">BV - Oman</option>
  <option value="BV - Dubai">BV - Dubai</option>
  <option value="LRQA - Mumbai - SDS">LRQA - Mumbai - SDS</option>
  <option value="TUV Nord India - Mumbai">TUV Nord India - Mumbai</option>
  <option value="TUV Nord India - Noida">TUV Nord India - Noida</option>
  <option value="TUV Nord India - Hydrabad">TUV Nord India - Hydrabad</option>
  <option value="TUV Nord India - Bangaluru">TUV Nord India - Bangaluru</option>
  <option value="TUV Nord India - Coimbatore">TUV Nord India - Coimbatore</option>
  <option value="TUV Nord India - Chennai">TUV Nord India - Chennai</option>
  <option value="TUV Nord India - Trichy">TUV Nord India - Trichy</option>
  <option value="TUV Nord India - Kolkata">TUV Nord India - Kolkata</option>
  <option value="TUV Nord India - Vadodara">TUV Nord India - Vadodara</option>
  <option value="Competent Inspectorate and Consultants Pvt Ltd - Hyderabad">Competent Inspectorate and Consultants Pvt Ltd - Hyderabad</option>
  <option value="TATA PROJECTS LIMITED - Hyderabad">TATA PROJECTS LIMITED - Hyderabad</option>
  <option value="DNV - Mumbai">DNV - Mumbai</option>
  <option value="Applus India Private Limited - Hyderabad">Applus India Private Limited - Hyderabad</option>
  <option value="TUV Rheinland (India) - Bangaluru">TUV Rheinland (India) - Bangaluru</option>
  <option value="TUV Rheinland (India) - Mumbai">TUV Rheinland (India) - Mumbai</option>
  <option value="Inspection Verification Bureau India (IVBI) - Kerala">Inspection Verification Bureau India (IVBI) - Kerala</option>
  <option value="Astron Certification P Ltd - Mumbai">Astron Certification P Ltd - Mumbai</option>
  <option value="Bureau Veritas (I) Pvt. Ltd - Mumbai">Bureau Veritas (I) Pvt. Ltd - Mumbai</option>
  <option value="BUREAU VERITAS (I) PVT. LTD - MUMBAI - ATS">BUREAU VERITAS (I) PVT. LTD - MUMBAI - ATS</option>
  <option value="Bureau Veritas (I) Pvt. Ltd - Vadodara">Bureau Veritas (I) Pvt. Ltd - Vadodara</option>
  <option value="IRCLASS Systems & Solutions Pvt. Ltd - Mumbai">IRCLASS Systems & Solutions Pvt. Ltd - Mumbai</option>
  <option value="IRCLASS Systems & Solutions Pvt. Ltd - Vadodara">IRCLASS Systems & Solutions Pvt. Ltd - Vadodara</option>
  <option value="EBULLIENT QUALITY SERVICES PVT. LTD">EBULLIENT QUALITY SERVICES PVT. LTD</option>
  <option value="International Inspection Services Pvt Ltd - Hyderabad">International Inspection Services Pvt Ltd - Hyderabad</option>
  <option value="Edlipse Engg. Global Pvt. Ltd - Noida">Edlipse Engg. Global Pvt. Ltd - Noida</option>
  <option value="DEKRA (India) Pvt Ltd.">DEKRA (India) Pvt Ltd.</option>
  <option value="BSCIC Certifications Pvt. Ltd - Haryana">BSCIC Certifications Pvt. Ltd - Haryana</option>
  <option value="SGS India Pvt. Ltd. - Mumbai">SGS India Pvt. Ltd. - Mumbai</option>
  <option value="RITES Ltd. - Haryana">RITES Ltd. - Haryana</option>
  <option value="International Certification Services Pvt. Ltd.">International Certification Services Pvt. Ltd.</option>
  <option value="ICS India Pvt. Ltd.">ICS India Pvt. Ltd.</option>
  <option value="TÜV SÜD South Asia Pvt. Ltd.">TÜV SÜD South Asia Pvt. Ltd.</option>
  <option value="TUV Sud - ITALIA">TUV Sud - ITALIA</option>
  <option value="TUV Sud - China">TUV Sud - China</option>
  <option value="Quality Evaluation and Systems Team Pvt. Ltd.">Quality Evaluation and Systems Team Pvt. Ltd.</option>
  <option value="RINA India Pvt. Ltd.">RINA India Pvt. Ltd.</option>
  <option value="Apave Assessments India Pvt. Ltd. - Bhivandi">Apave Assessments India Pvt. Ltd. - Bhivandi</option>
  <option value="Gulf Lloyds Industrial Services (India) Pvt. Ltd. - Ahmedabad">Gulf Lloyds Industrial Services (India) Pvt. Ltd. - Ahmedabad</option>
  <option value="Industrial Inspection and Verification Services India Pvt. Ltd.">Industrial Inspection and Verification Services India Pvt. Ltd.</option>
  <option value="Bureau Veritas - UAE">Bureau Veritas - UAE</option>
  <option value="K2M Consultant & Services Co., Ltd.">K2M Consultant & Services Co., Ltd.</option>
  <option value="KOREAN TECHNO INSPECTION MIDDLE EAST Co. LLC">KOREAN TECHNO INSPECTION MIDDLE EAST Co. LLC</option>
  <option value="TQ Services Europe GMBH">TQ Services Europe GMBH</option>
  <option value="Fulkrum - United Kingdom">Fulkrum - United Kingdom</option>
  <option value="Fulkrum - Malaysia">Fulkrum - Malaysia</option>
  <option value="Fulkrum - Australia">Fulkrum - Australia</option>
  <option value="Fulkrum - Italy">Fulkrum - Italy</option>
  <option value="Fulkrum - Abu Dhabi">Fulkrum - Abu Dhabi</option>
  <option value="Fulkrum - Saudi Arebia">Fulkrum - Saudi Arebia</option>
  <option value="Fulkrum - Texas">Fulkrum - Texas</option>
  <option value="Fulkrum - Brazil">Fulkrum - Brazil</option>
  <option value="APS CONSULTANCY PRIVATE LIMITED">APS CONSULTANCY PRIVATE LIMITED</option>
  <option value="INTERNATIONAL INSPECTION SERVICES (P) LTD">INTERNATIONAL INSPECTION SERVICES (P) LTD</option>
  <option value="IRCLASS Systems & Solutions Pvt Ltd - Mumbai">IRCLASS Systems & Solutions Pvt Ltd - Mumbai</option>
  <option value="IRCLASS Systems & Solutions Pvt Ltd - Hyderabad">IRCLASS Systems & Solutions Pvt Ltd - Hyderabad</option>
  <option value="Ohm Inspection Services">Ohm Inspection Services</option>
  <option value="INSPECTION SERVIS">INSPECTION SERVIS</option>
  <option value="Applus China">Applus China</option>
  <option value="TÜV NORD EGYPT">TÜV NORD EGYPT</option>
  <option value="E2P Consultancy & Services FZE">E2P Consultancy & Services FZE</option>
  <option value="ACES Global Quality Services">ACES Global Quality Services</option>
  <option value="BUREAU VERITAS ITALIA">BUREAU VERITAS ITALIA</option>
  <option value="HQTS Group">HQTS Group</option>
  <option value="EXCELLENCE QUALITY SERVICES PRIVATE LIMITED">EXCELLENCE QUALITY SERVICES PRIVATE LIMITED</option>
  <option value="TUV Nord India - Pune">TUV Nord India - Pune</option>
  <option value="MSH Inspection & Testing">MSH Inspection & Testing</option>
  <option value="Elchmey">Elchmey</option>
  <option value="CHITAKO">CHITAKO</option>
  <option value="ENIECO">ENIECO</option>
  <option value="Advance Technology Group">Advance Technology Group</option>
  <option value="Cutech Quality Solutions Pte Ltd">Cutech Quality Solutions Pte Ltd</option>
  <option value="TUV NORD INDIA - AHMEDABAD">TUV NORD INDIA - AHMEDABAD</option>
  <option value="Scorpioslax">Scorpioslax</option>
  <option value="HaloQC online Pvt Ltd.">HaloQC online Pvt Ltd.</option>
  <option value="INSPECTLAB SA Quality Services">INSPECTLAB SA Quality Services</option>
  <option value="Adhuni Engineering Services">Adhuni Engineering Services</option>
  <option value="DNV ITALIA">DNV ITALIA</option>
  <option value="HQTS - India">HQTS - India</option>
  <option value="Steel Inspect">Steel Inspect</option>
  <option value="DNV Italia">DNV Italia</option>
  <option value="TUV NORD Saudi Arabia">TUV NORD Saudi Arabia</option>
  <option value="TUV NORD Ahmedabad">TUV NORD Ahmedabad</option>
  <option value="Eram International Quality & Standardization LLC">Eram International Quality & Standardization LLC</option>
  <option value="Global Pageant">Global Pageant</option>
  <option value="TÜV Rheinland - China">TÜV Rheinland - China</option>
  <option value="ROUNAK ENTERPRISE">ROUNAK ENTERPRISE</option>
  <option value="PPI QUALITY & ENGINEERING">PPI QUALITY & ENGINEERING</option>
  <option value="DELTA GULF Quality Certification Services LLC">DELTA GULF Quality Certification Services LLC</option>
  <option value="Sicim">Sicim</option>
  <option value="OCA Global">OCA Global</option>
  <option value="DNV OMAN">DNV OMAN</option>
  <option value="TC2 Group">TC2 Group</option>
  <option value="HQTS">HQTS</option>
  <option value="BV - Kazakhstan">BV - Kazakhstan</option>
  <option value="CAPSA Engineering & Contracting">CAPSA Engineering & Contracting</option>
  <option value="DYC Global Private Limited">DYC Global Private Limited</option>
  <option value="APPLUS VELOSI">APPLUS VELOSI</option>
  <option value="GB">GB</option>
  <option value="MANAV JADHAV">MANAV JADHAV</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="subjectLine">Subject Line</label>
                <input type="text" id="subjectLine" name="SubjectLine" />
              </div>

             </div>

             <div className="form-section">

              <div className="form-group">
                <label htmlFor="clientRequirement">Client Requirement</label>
                <textarea id="clientRequirement" name="ClientRequirement" rows="3" required></textarea>
              </div>

              <div className="form-group">
                <label htmlFor="vendor">Vendor</label>
                <input type="text" id="vendor" name="Vendor" required />
              </div>

              <div className="form-group">
                <label htmlFor="location">Location</label>
                <input type="text" id="location" name="Location" required />
              </div>

             </div>

              <div className="form-section">
                
              <div className="form-group">
                <label htmlFor="country">Country</label>
                <select id="country" name="Country" required>
  <option value="">--Select Country--</option>
  <option value="Afghanistan">Afghanistan</option>
  <option value="Albania">Albania</option>
  <option value="Algeria">Algeria</option>
  <option value="Andorra">Andorra</option>
  <option value="Angola">Angola</option>
  <option value="Antigua and Barbuda">Antigua and Barbuda</option>
  <option value="Argentina">Argentina</option>
  <option value="Armenia">Armenia</option>
  <option value="Australia">Australia</option>
  <option value="Austria">Austria</option>
  <option value="Azerbaijan">Azerbaijan</option>
  <option value="Bahamas">Bahamas</option>
  <option value="Bahrain">Bahrain</option>
  <option value="Bangladesh">Bangladesh</option>
  <option value="Barbados">Barbados</option>
  <option value="Belarus">Belarus</option>
  <option value="Belgium">Belgium</option>
  <option value="Belize">Belize</option>
  <option value="Benin">Benin</option>
  <option value="Bhutan">Bhutan</option>
  <option value="Bolivia">Bolivia</option>
  <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
  <option value="Botswana">Botswana</option>
  <option value="Brazil">Brazil</option>
  <option value="Brunei">Brunei</option>
  <option value="Bulgaria">Bulgaria</option>
  <option value="Burkina Faso">Burkina Faso</option>
  <option value="Burundi">Burundi</option>
  <option value="Cabo Verde">Cabo Verde</option>
  <option value="Cambodia">Cambodia</option>
  <option value="Cameroon">Cameroon</option>
  <option value="Canada">Canada</option>
  <option value="Central African Republic">Central African Republic</option>
  <option value="Chad">Chad</option>
  <option value="Chile">Chile</option>
  <option value="China">China</option>
  <option value="Colombia">Colombia</option>
  <option value="Comoros">Comoros</option>
  <option value="Congo (Congo-Brazzaville)">Congo (Congo-Brazzaville)</option>
  <option value="Costa Rica">Costa Rica</option>
  <option value="Croatia">Croatia</option>
  <option value="Cuba">Cuba</option>
  <option value="Cyprus">Cyprus</option>
  <option value="Czech Republic">Czech Republic</option>
  <option value="Democratic Republic of the Congo">Democratic Republic of the Congo</option>
  <option value="Denmark">Denmark</option>
  <option value="Djibouti">Djibouti</option>
  <option value="Dominica">Dominica</option>
  <option value="Dominican Republic">Dominican Republic</option>
  <option value="Ecuador">Ecuador</option>
  <option value="Egypt">Egypt</option>
  <option value="El Salvador">El Salvador</option>
  <option value="Equatorial Guinea">Equatorial Guinea</option>
  <option value="Eritrea">Eritrea</option>
  <option value="Estonia">Estonia</option>
  <option value="Eswatini">Eswatini</option>
  <option value="Ethiopia">Ethiopia</option>
  <option value="Fiji">Fiji</option>
  <option value="Finland">Finland</option>
  <option value="France">France</option>
  <option value="Gabon">Gabon</option>
  <option value="Gambia">Gambia</option>
  <option value="Georgia">Georgia</option>
  <option value="Germany">Germany</option>
  <option value="Ghana">Ghana</option>
  <option value="Greece">Greece</option>
  <option value="Grenada">Grenada</option>
  <option value="Guatemala">Guatemala</option>
  <option value="Guinea">Guinea</option>
  <option value="Guinea-Bissau">Guinea-Bissau</option>
  <option value="Guyana">Guyana</option>
  <option value="Haiti">Haiti</option>
  <option value="Honduras">Honduras</option>
  <option value="Hungary">Hungary</option>
  <option value="Iceland">Iceland</option>
  <option value="India">India</option>
  <option value="Indonesia">Indonesia</option>
  <option value="Iran">Iran</option>
  <option value="Iraq">Iraq</option>
  <option value="Ireland">Ireland</option>
  <option value="Israel">Israel</option>
  <option value="Italy">Italy</option>
  <option value="Ivory Coast">Ivory Coast</option>
  <option value="Jamaica">Jamaica</option>
  <option value="Japan">Japan</option>
  <option value="Jordan">Jordan</option>
  <option value="Kazakhstan">Kazakhstan</option>
  <option value="Kenya">Kenya</option>
  <option value="Kiribati">Kiribati</option>
  <option value="Kuwait">Kuwait</option>
  <option value="Kyrgyzstan">Kyrgyzstan</option>
  <option value="Laos">Laos</option>
  <option value="Latvia">Latvia</option>
  <option value="Lebanon">Lebanon</option>
  <option value="Lesotho">Lesotho</option>
  <option value="Liberia">Liberia</option>
  <option value="Libya">Libya</option>
  <option value="Liechtenstein">Liechtenstein</option>
  <option value="Lithuania">Lithuania</option>
  <option value="Luxembourg">Luxembourg</option>
  <option value="Madagascar">Madagascar</option>
  <option value="Malawi">Malawi</option>
  <option value="Malaysia">Malaysia</option>
  <option value="Maldives">Maldives</option>
  <option value="Mali">Mali</option>
  <option value="Malta">Malta</option>
  <option value="Marshall Islands">Marshall Islands</option>
  <option value="Mauritania">Mauritania</option>
  <option value="Mauritius">Mauritius</option>
  <option value="Mexico">Mexico</option>
  <option value="Micronesia">Micronesia</option>
  <option value="Moldova">Moldova</option>
  <option value="Monaco">Monaco</option>
  <option value="Mongolia">Mongolia</option>
  <option value="Montenegro">Montenegro</option>
  <option value="Morocco">Morocco</option>
  <option value="Mozambique">Mozambique</option>
  <option value="Myanmar">Myanmar</option>
  <option value="Namibia">Namibia</option>
  <option value="Nauru">Nauru</option>
  <option value="Nepal">Nepal</option>
  <option value="Netherlands">Netherlands</option>
  <option value="New Zealand">New Zealand</option>
  <option value="Nicaragua">Nicaragua</option>
  <option value="Niger">Niger</option>
  <option value="Nigeria">Nigeria</option>
  <option value="North Korea">North Korea</option>
  <option value="North Macedonia">North Macedonia</option>
  <option value="Norway">Norway</option>
  <option value="Oman">Oman</option>
  <option value="Pakistan">Pakistan</option>
  <option value="Palau">Palau</option>
  <option value="Palestine">Palestine</option>
  <option value="Panama">Panama</option>
  <option value="Papua New Guinea">Papua New Guinea</option>
  <option value="Paraguay">Paraguay</option>
  <option value="Peru">Peru</option>
  <option value="Philippines">Philippines</option>
  <option value="Poland">Poland</option>
  <option value="Portugal">Portugal</option>
  <option value="Qatar">Qatar</option>
  <option value="Romania">Romania</option>
  <option value="Russia">Russia</option>
  <option value="Rwanda">Rwanda</option>
  <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
  <option value="Saint Lucia">Saint Lucia</option>
  <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
  <option value="Samoa">Samoa</option>
  <option value="San Marino">San Marino</option>
  <option value="Sao Tome and Principe">Sao Tome and Principe</option>
  <option value="Saudi Arabia">Saudi Arabia</option>
  <option value="Senegal">Senegal</option>
  <option value="Serbia">Serbia</option>
  <option value="Seychelles">Seychelles</option>
  <option value="Sierra Leone">Sierra Leone</option>
  <option value="Singapore">Singapore</option>
  <option value="Slovakia">Slovakia</option>
  <option value="Slovenia">Slovenia</option>
  <option value="Solomon Islands">Solomon Islands</option>
  <option value="Somalia">Somalia</option>
  <option value="South Africa">South Africa</option>
  <option value="South Korea">South Korea</option>
  <option value="South Sudan">South Sudan</option>
  <option value="Spain">Spain</option>
  <option value="Sri Lanka">Sri Lanka</option>
  <option value="Sudan">Sudan</option>
  <option value="Suriname">Suriname</option>
  <option value="Sweden">Sweden</option>
  <option value="Switzerland">Switzerland</option>
  <option value="Syria">Syria</option>
  <option value="Taiwan">Taiwan</option>
  <option value="Tajikistan">Tajikistan</option>
  <option value="Tanzania">Tanzania</option>
  <option value="Thailand">Thailand</option>
  <option value="Timor-Leste">Timor-Leste</option>
  <option value="Togo">Togo</option>
  <option value="Tonga">Tonga</option>
  <option value="Trinidad and Tobago">Trinidad and Tobago</option>
  <option value="Tunisia">Tunisia</option>
  <option value="Turkey">Turkey</option>
  <option value="Turkmenistan">Turkmenistan</option>
  <option value="Tuvalu">Tuvalu</option>
  <option value="Uganda">Uganda</option>
  <option value="Ukraine">Ukraine</option>
  <option value="UAE">UAE</option>
  <option value="UK">UK</option>
  <option value="USA">USA</option>
  <option value="Uruguay">Uruguay</option>
  <option value="Uzbekistan">Uzbekistan</option>
  <option value="Vanuatu">Vanuatu</option>
  <option value="Vatican City">Vatican City</option>
  <option value="Venezuela">Venezuela</option>
  <option value="Vietnam">Vietnam</option>
  <option value="Yemen">Yemen</option>
  <option value="Zambia">Zambia</option>
  <option value="Zimbabwe">Zimbabwe</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="inspector">Inspector</label>
                <input type="text" id="inspector" name="Inspector" required />
              </div>

              <div className="form-group">
                <label htmlFor="tentativeDate">Tentative Date of Inspection</label>
                <input type="text" id="tentativeDate" name="TentativeDateOfInspection" />
              </div>

             </div>

             <div className="form-section">

              <div className="form-group">
                <label htmlFor="numberOfDays">Number of Days</label>
                <input type="text" id="numberOfDaysValue" name="NumberOfDaysValue" placeholder="Enter value" />
              </div>
                
             </div>

             <div class="divider"><span></span></div>

             <div className="form-section">
              
              <div className="form-group">
                <label htmlFor="costCurrency">Cost Currency</label>
                <select id="costCurrency" name="CostCurrency" >
                  <option value="" disabled selected>--Select Currency--</option>
                  <option value="USD">USD</option>
                  <option value="INR">INR</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="AED">AED</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="cost">Cost</label>
                <input type="number" step="0.01" id="cost" name="Cost" min="0" />
              </div> 

              <div className="form-group">
                <label htmlFor="costInINR">Cost in INR</label>
                <input type="number" step="0.01" id="costInINR" name="CostInINR" min="0" />
              </div>

             </div>

             <div className="form-section">

              <div className="form-group">
                <label htmlFor="offeredPriceCurrency">Offered Price Currency</label>
                <select id="offeredPriceCurrency" name="OfferedPriceCurrency" >
                  <option value="" disabled selected>--Select Currency--</option>
                  <option value="USD">USD</option>
                  <option value="INR">INR</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="AED">AED</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="offeredPrice">Offered Price</label>
                <input type="number" step="0.01" id="offeredPrice" name="OfferedPrice" min="0" />
              </div>

              <div className="form-group">
                <label htmlFor="offeredPriceInINR">Offered Price in INR</label>
                <input type="number" step="0.01" id="offeredPriceInINR" name="OfferedPriceInINR" min="0" />
              </div>
                
             </div>

             <div className="form-section">

              <div className="form-group">
                <label htmlFor="margin">Margin(%)</label>
                <input type="text" id="margin" name="Margin" step="0.01" />
              </div>

              <div className="form-group">
                <label htmlFor="status">Status</label>
                <select id="status" name="Status" required>
                  <option value="IN PROCESS">IN PROCESS</option>
                  <option value="BIDDING">BIDDING</option>
                  <option value="WON">WON</option>
                  <option value="LOST">LOST</option>
                  <option value="REGRET">REGRET</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="ownerCoordinator">Owner/Coordinator</label>
                <select id="ownerCoordinator" name="OwnerCoordinator" required>
                  <option value="" disabled selected>--Select Coordinator--</option>
                  <option value="Arpita">Arpita</option>
                  <option value="Vijay">Vijay</option>
                  <option value="Divya">Divya</option>
                  <option value="Indu">Indu</option>
                  <option value="Kavan">Kavan</option>
                  <option value="Neel">Neel</option>
                  <option value="Priti">Priti</option>
                  <option value="Deep">Deep</option>
                  <option value="Bhagya">Bhagya</option>
                </select>
              </div>

             </div>

             <div className="form-section">
                
              <div className="form-group" id="bottom">
                <label htmlFor="remarks">Remarks</label>
                <textarea id="remarks" name="Remarks" rows="3"></textarea>
              </div>

             </div>


              <div className="form-submit-button">
                <button className="submit-button" type="submit">
                  Submit
                </button>
              </div>

            </div>
            </form>

            <div
              id="popup"
              style={{
                display: "none",
                position: "fixed",
                top: 20,
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "15px 25px",
                borderRadius: "5px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
                zIndex: 1000,
                opacity: 0,
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              Inquiry submitted successfully!
            </div>
          </div>
        </main>
      </div>
    </div>
  // }
  // </div>
  );
}
